import "./styles.css";
import { getSignedImageSrc } from "../../mediaUtils";
import { isNullOrUndefined } from "../../utils";
import { ReactComponent as IconPicture } from "../../assets/icon_picture.svg";

const DEFAULT_SIZE = 32;
const DEFAULT_BORDER = 4;

function ImageAsset(props) {
  const {
    imageUrl,
    previewImageData, // base64
    size = DEFAULT_SIZE,
    border = DEFAULT_BORDER,
    onClick,
  } = props;

  const hasImage =
    !isNullOrUndefined(previewImageData) || !isNullOrUndefined(imageUrl);

  // If present, show the previewImageData over the imageUrl
  const backgroundImage = !isNullOrUndefined(previewImageData)
    ? `url(data:image/jpeg;base64,${previewImageData}`
    : `url(${getSignedImageSrc(imageUrl)})`;

  const imageStyle = !hasImage
    ? {
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${border}px`,
        background:
          "linear-gradient(30turn, var(--gray-medium-color), var(--gray-dimmed-color))",
      }
    : {
        backgroundColor: "var(--gray-dimmed-color)",
        backgroundImage: backgroundImage,
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${border}px`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
      };

  const placeholderImageStyle = {
    width: `${size * 0.75}px`,
    height: `${size * 0.75}px`,
  };
  const clickable = !isNullOrUndefined(onClick);

  return (
    <div
      className={`image-asset${clickable ? " clickable" : ""}${
        !hasImage ? " empty" : ""
      }`}
      style={imageStyle}
      onClick={() => {
        if (clickable) {
          onClick();
        }
      }}
    >
      {!hasImage && <IconPicture style={placeholderImageStyle} />}
    </div>
  );
}

export default ImageAsset;
